<script setup>
import { toRefs, defineProps, defineEmits, onMounted, ref, defineExpose, nextTick } from 'vue';
import Swal from "sweetalert2";
// import i18n from "@/i18n"
import { getHscode_management_index_category, get_index_standard_calculation_mode } from "@/service/index"
import groupIndicatorListCom from './group_indicatorList.vue';
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
const props = defineProps({
    groupInfoList: {
        type: Array,
        default: () => {
            return []
        }
    },
    isCheckForm: {
        type: Boolean,
        default: false
    },
    currentTab: {
        type: Number,
        default: 1
    },
})

const emits = defineEmits(["onAddgroupindicator",
    "onAddGroupLevel1",
    "onDeleteGroupLevel1",
    "onAddGroupLevel2",
    "onDeleteGroupLevel2",
    "onAddGroupLevel3",
    "onDeleteGroupLevel3",
    "onDeleteGroupindicator",
    "onDeleteGroup",
    "showInfo",
    "update:groupInfoList"
])
const index_standard_calculation_mode_list = ref([])
const { groupInfoList, currentTab } = toRefs(props)
const index_category_lsit = ref([])
// const repeatList = ref({})


const repeatGroupList1 = ref({}) // 重复的组名 子组名数据
const repeatGroupList1_en = ref({}) // 英文重复的组名 子组名数据
const repeatGroupList = ref([]) // 重复的类型数据
// const repeatGroupList2 = ref([])
// const repeatGroupLis3 = ref([])


const onaddGroupLevel1 = () => {
    //添加指标分类
    let groupInfo = {
        add: true,
        category_name: '', // 新增指标类别
        group_name: '', // 新增指标类别描述
        group_name_en: '', // 新增指标类别描述
        indicatorList: [], //指标
        expand: true, // 默认展开
        children: [
            {
                add: true,
                group_name: '',
                group_name_en: '',
                indicatorList: [], //指标
                children: [
                    {
                        add: true,
                        group_name: '',
                        group_name_en: '',
                        indicatorList: [
                            {
                                add: true,
                                name: '',
                                name_en: '',
                                unit: '',
                                unit_en: '',
                                value: '',
                                reference: '',
                                reference_en: '',
                                threshold: '',
                                judgement_model: '',
                                is_applicable: '0',
                                is_specific: '0',
                                calculation_mode: '',
                            }
                        ],
                    },
                ]
            },
        ]

    };
    groupInfoList.value.push(groupInfo)
}
const ondeleteGroupLevel1 = (i) => {
    // 删除指标分类
    groupInfoList.value.splice(i, 1);
}
const onaddGroupLevel2 = (index) => {
    // 添加组分类
    let group_info = {
        group_name: '',
        group_name_en: '',
        add: true,
        indicatorList: [],
        children: [
            {
                group_name: '',
                group_name_en: '',
                add: true,
                indicatorList: [
                    {
                        add: true,
                        name: '',
                        name_en: '',
                        unit: '',
                        unit_en: '',
                        value: '',
                        reference: '',
                        reference_en: '',
                        threshold: '',
                        judgement_model: '',
                        is_applicable: '0',
                        is_specific: '0',
                        calculation_mode: '',
                    }
                ],
            },
        ]
    }
    groupInfoList.value[index].children.push(group_info)
    nextTick(() => {
        const element = document.getElementById(`myGroup_${index}_${groupInfoList.value[index].children.length - 1}`);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    })
}
const ondeleteGroupLevel2 = ({ index, i }) => {
    // 删除组分类
    groupInfoList.value[index].children.splice(i, 1)
}
const onaddGroupLevel3 = ({ index, group_key }) => {
    // 添加子分类组
    let group_info = {
        group_name: '',
        group_name_en: '',
        add: true,
        indicatorList: [
            {
                add: true,
                name: '',
                name_en: '',
                unit: '',
                unit_en: '',
                value: '',
                reference: '',
                reference_en: '',
                threshold: '',
                judgement_model: '',
                is_applicable: '0',
                is_specific: '0',
                calculation_mode: '',
            }
        ],
    }
    groupInfoList.value[index].children[group_key].children.push(group_info)
    nextTick(() => {
        const element = document.getElementById(`myGroup_${index}_${group_key}_${groupInfoList.value[index].children[group_key].children.length - 1}`);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    })
}
const ondeleteGroupLevel3 = ({ index, group_key, group_son_key }) => {
    // 删除子分类组
    groupInfoList.value[index].children[group_key].children.splice(group_son_key, 1)
}

/**lecel1 */
const addGroupLevel1 = () => {
    // 添加最顶级的父级  指标分类
    onaddGroupLevel1();
    emits("update:groupInfoList", groupInfoList.value);
    // 然后定位到最新的位置
    nextTick(() => {
        const element = document.getElementById(`myGroup_${groupInfoList.value.length - 1}`);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    })
}

const deleteGroupLevel1 = (i) => {
    // 删除最顶级分类
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            ondeleteGroupLevel1(i);
            emits("update:groupInfoList", groupInfoList.value);
            changeGroupCategory('')
        }
    });
}
/**lecel1 */

/**lecel2 */
const addGroupLevel2 = (index) => {
    // 添加最顶级的父级  指标分类
    onaddGroupLevel2(index);
    emits("update:groupInfoList", groupInfoList.value);
}

const deleteGroupLevel2 = (index, i) => {
    // 删除最顶级分类
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            ondeleteGroupLevel2({ index, i });
            emits("update:groupInfoList", groupInfoList.value);
            changeGroup(index)
        }
    });
}
/**lecel2 */

/**level3 */
const addGroupLevel3 = (index, group_key) => {
    // 添加第三级的父级  指标分类
    onaddGroupLevel3({ index, group_key });
    emits("update:groupInfoList", groupInfoList.value);
}

const deleteGroupLevel3 = (index, group_key, group_son_key) => {
    // 删除第三级分类
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            ondeleteGroupLevel3({ index, group_key, group_son_key });
            emits("update:groupInfoList", groupInfoList.value);
            changeGroup1(index, group_key)
        }
    });
}
/**level3 */

/**指标部分 */
// const addGroupindicator = (index, grop_son_key, grop_son_son_key) => {
//     //添加指标
//     emits("onAddgroupindicator", { index, grop_son_key, grop_son_son_key })
// }

// const deleteGroupindicator = (index, grop_son_key, grop_son_son_key, groupindicatorindicator_index) => {
//     //删除指标
//     Swal.fire({
//         title: getLangValue("base.delete_alert_title"),
//         text: getLangValue("base.delete_alert_info"),
//         icon: "warning",
//         showCancelButton: true,
//         cancelButtonColor: "#f46a6a",
//         confirmButtonColor: "#34c38f",
//         confirmButtonText: getLangValue("base.done"),
//         cancelButtonText: getLangValue("base.cancel"),
//     }).then(async (result) => {
//         if (result.isConfirmed) {
//             emits("onDeleteGroupindicator", { index, grop_son_key, grop_son_son_key, groupindicatorindicator_index })
//         }
//     });
// }
/**指标部分 */

const showInfo = (type) => {
    emits('showInfo', type)
}

const getIndicatorCategory = async () => {
    const resp = await getHscode_management_index_category();
    if (resp) {
        index_category_lsit.value = resp.payload;
        // 获取指标类目
        for (const item in index_category_lsit.value) {
            // 先把可追溯性 不可选
            if (index_category_lsit.value[item].id == 1) {
                index_category_lsit.value[item].disabled = true
            }
        }
    }
}

const getCategoryName = (val, key='zh') => {
    if (val === '') return ""
    return key=='zh'? index_category_lsit.value.find(item => item.id === val)?.name || "":  index_category_lsit.value.find(item => item.id === val)?.name_en || ""
}

const changeGroupCategory = (key) => {
    if (groupInfoList.value[key] && groupInfoList.value[key].group_name === '') {
        groupInfoList.value[key].group_name = getCategoryName(groupInfoList.value[key].category_name)
        groupInfoList.value[key].group_name_en = getCategoryName(groupInfoList.value[key].category_name, 'en')
    }
    // 判断类型是否重复
    if (groupInfoList.value.length > 1) {
        let arr = groupInfoList.value.map(item => {
            return item.category_name
        })
        const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
        if (duplicates.length) {
            repeatGroupList.value = duplicates
            emits("showInfo", 2)
        } else {
            repeatGroupList.value = []
        }
    } else {
        repeatGroupList.value = []
    }
}


const changeGroup = (index,) => {
    // 分类组名称重复
    // const { group_name } = groupInfoList.value[index].children[i]

    const children = groupInfoList.value[index].children;
    // const { name } = indicatorList[g_i];
    // 筛选名称看是否重复
    let arr = children.map(item => item.group_name)
    // 筛选数量大于1的内容
    const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
    if (duplicates.length) {
        if (!repeatGroupList1.value[index]) {
            repeatGroupList1.value[index] = []
            // repeatGroupList1.value[index].repeat = []
        }
        repeatGroupList1.value[index] = duplicates;
        emits("showInfo", 0)
    } else {
        repeatGroupList1.value[index] = []
        // repeatGroupList.value.remove(0)
    }
}

const changeGroup_en = (index,) => {
    // 分类组名称重复
    // const { group_name } = groupInfoList.value[index].children[i]

    const children = groupInfoList.value[index].children;
    // const { name } = indicatorList[g_i];
    // 筛选名称看是否重复
    let arr = children.map(item => item.group_name_en)
    // 筛选数量大于1的内容
    const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
    if (duplicates.length) {
        if (!repeatGroupList1_en.value[index]) {
            repeatGroupList1_en.value[index] = []
            // repeatGroupList1.value[index].repeat = []
        }
        repeatGroupList1_en.value[index] = duplicates;
        emits("showInfo", 0)
    } else {
        repeatGroupList1_en.value[index] = []
        // repeatGroupList.value.remove(0)
    }
}


const changeGroup1 = (index, grop_son_key) => {
    const { children } = groupInfoList.value[index].children[grop_son_key];
    // const { name } = indicatorList[g_i];
    // 筛选名称看是否重复
    let arr = children.map(item => item.group_name)
    // 筛选数量大于1的内容
    const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
    if (duplicates.length) {
        if (!repeatGroupList1.value[`${index}-${grop_son_key}_son`]) {
            repeatGroupList1.value[`${index}-${grop_son_key}_son`] = []
        }
        repeatGroupList1.value[`${index}-${grop_son_key}_son`] = duplicates;
        emits("showInfo", 1)
    } else {
        if (repeatGroupList1.value[`${index}-${grop_son_key}_son`]) {
            repeatGroupList1.value[`${index}-${grop_son_key}_son`] = []
        }
    }
    // console.log(repeatGroupList1.value[`${index}-${grop_son_key}_son`]);
}

const changeGroup1_en = (index, grop_son_key) => {
    const { children } = groupInfoList.value[index].children[grop_son_key];
    // const { name } = indicatorList[g_i];
    // 筛选名称看是否重复
    let arr = children.map(item => item.group_name_en)
    // 筛选数量大于1的内容
    const duplicates = arr.filter((value, index, self) => self.indexOf(value) !== index);
    if (duplicates.length) {
        if (!repeatGroupList1_en.value[`${index}-${grop_son_key}_son`]) {
            repeatGroupList1_en.value[`${index}-${grop_son_key}_son`] = []
        }
        repeatGroupList1_en.value[`${index}-${grop_son_key}_son`] = duplicates;
        emits("showInfo", 1)
    } else {
        if (repeatGroupList1_en.value[`${index}-${grop_son_key}_son`]) {
            repeatGroupList1_en.value[`${index}-${grop_son_key}_son`] = []
        }
    }
    // console.log(repeatGroupList1.value[`${index}-${grop_son_key}_son`]);
}

const _get_index_standard_calculation_mode = async () => {
    //? 获取计算方式list
    const reps = await get_index_standard_calculation_mode()
    if (reps.code == 0) {
        index_standard_calculation_mode_list.value = reps.payload
    }
}


/**
 * 增加排序
 */
const draggingIndex = ref(null); // 大类拖拽index
const draggingIndex1 = ref(null); // 指标组拖拽index
const draggingIndex2 = ref(null); // 指标子组拖拽index


const onDragStart = (index, type = 1) => {
    // 拖拽开始
    switch (type) {
        case 1:
            draggingIndex.value = index;
            break;
        case 2:
            draggingIndex1.value = index;
            break;
        case 3:
            draggingIndex2.value = index;
            break;
        default:
            break;
    }

};

const onDragOver = (index,) => {
    // 拖拽结束
    if (draggingIndex.value !== index) {
        const draggedItem = groupInfoList.value.splice(draggingIndex.value, 1)[0];
        groupInfoList.value.splice(index, 0, draggedItem);
        draggingIndex.value = index;
    }
    // 移除所有dragging
    setTimeout(() => {
        document.querySelectorAll('.dragging').forEach(el => el.classList.remove('dragging'));
    }, 100)
};

const onDragOver1 = (index, g_index) => {
    // 拖拽结束
    console.log(index, draggingIndex1.value);
    if (draggingIndex1.value !== index) {
        const draggedItem = groupInfoList.value[g_index].children.splice(draggingIndex1.value, 1)[0];
        groupInfoList.value[g_index].children.splice(index, 0, draggedItem);
        draggingIndex1.value = index;
    }
    // 移除所有dragging
    setTimeout(() => {
        document.querySelectorAll('.dragging').forEach(el => el.classList.remove('dragging'));
    }, 100)
};

const onDragOver2 = (index, g_index, g_index_index) => {
    // 拖拽结束
    if (draggingIndex2.value !== index) {
        const draggedItem = groupInfoList.value[g_index].children[g_index_index].children.splice(draggingIndex2.value, 1)[0];
        groupInfoList.value[g_index].children[g_index_index].children.splice(index, 0, draggedItem);
        draggingIndex2.value = index;
    }
    // 移除所有dragging
    setTimeout(() => {
        document.querySelectorAll('.dragging').forEach(el => el.classList.remove('dragging'));
    }, 100)
};

const onDrop = (type = 1) => {
    // 离开
    switch (type) {
        case 1:
            draggingIndex.value = null;
            break;
        case 2:
            draggingIndex1.value = null;
            break;
        case 3:
            draggingIndex2.value = null;
            break;
        default:
            break;
    }
};

onMounted(() => {
    getIndicatorCategory();
    // 获取计算方式list
    _get_index_standard_calculation_mode();
})


defineExpose({
    repeatGroupList,
    repeatGroupList1,
    repeatGroupList1_en
})


</script>
<template>
    <div class="group-content" v-if="groupInfoList.length">
        <div class="group row " v-for="(group, index) in groupInfoList" :key="`group--${index}`">
            <div class="card py-2 list-group-item" :id="`myGroup_${index}`">
                <div class="d-flex align-items-center justify-content-between py-2"
                    style="border-bottom: 1px solid #E9EBEC;" draggable="true" @dragstart="() => onDragStart(index)"
                    @dragover.prevent="onDragOver(index)" @drop="onDrop(1)"
                    :class="{ dragging: draggingIndex === index }">
                    <div style="font-size: 16px; width: 240px;">
                        <input style="width: 200px;display: inline-block;" v-model="group.group_name" type="text"
                            :disabled="!group.add && !group.canedit" class="form-control " required
                            :placeholder="currentTab == 1 ? getLangValueByKey('hscode.category_name') : getLangValueByKey('hscode.category_name', 'en')"
                            :class="[
                                (isCheckForm && group.group_name === '') && 'is-invalid',]" v-show="currentTab == 1" />
                        <input style="width: 200px;display: inline-block;" v-model="group.group_name_en" type="text"
                            :disabled="!group.add && !group.canedit" class="form-control " required
                            :placeholder="currentTab == 1 ? getLangValueByKey('hscode.category_name') : getLangValueByKey('hscode.category_name', 'en')"
                            :class="[
                                (isCheckForm && group.group_name_en === '') && 'is-invalid',]"
                            v-show="currentTab == 2" />
                        <!-- 删除 -->
                        <i class=" ri-delete-bin-fill mx-2 text-danger" @click="deleteGroupLevel1(index)"
                            v-if="group.add || group.canedit" />
                    </div>
                    <div class="d-flex align-items-center ">
                        <span class="mx-2">{{
                            currentTab == 1 ? getLangValueByKey('hscode.indexClassification') :
                                getLangValueByKey('hscode.indexClassification', 'en')
                        }}:</span>
                        <Multiselect :disabled="!group.add && !group.canedit" style="width: 200px;" id="garment"
                            class="form-control" :class="[
                                (isCheckForm && group.category_name === '' || repeatGroupList.includes(group.category_name)) && 'is-invalid',
                            ]"
                            :placeholder="currentTab == 1 ? getLangValueByKey('hscode.category_name') : getLangValueByKey('hscode.category_name', 'en')"
                            v-model="group.category_name" :label="currentTab == 1 ? 'name' : 'name_en'" value-prop="id"
                            :close-on-select="true" :searchable="true" :create-option="false"
                            :options="index_category_lsit" @select="changeGroupCategory(index)" />
                        <button type="button" class="btn btn-primary mx-3 d-flex align-items-center"
                            style="background-color: #0AB39C;border: unset;" @click="addGroupLevel1(index)">
                            <i class="ri-add-circle-fill me-2" />
                            {{
                                // getLangValue("hscode.add_indicator_type")
                                currentTab == 1 ? getLangValueByKey('hscode.add_indicator_type') :
                                    getLangValueByKey('hscode.add_indicator_type', 'en')
                            }}</button>
                        <button type="button" class="btn btn-primary me-3 "
                            style="background-color: #0AB39C;border: unset;" @click="addGroupLevel2(index)">
                            <i class=" ri-add-fill me-2" />
                            {{
                                // getLangValue("hscode.add_group_type")
                                currentTab == 1 ? getLangValueByKey('hscode.add_group_type') :
                                    getLangValueByKey('hscode.add_group_type', 'en')
                            }}</button>
                        <!-- {{group.expand  }} -->
                        <span class="cursor-pointer" v-if="group.expand || typeof group.expand == 'undefined'"
                            @click="group.expand = false"> {{
                                // getLangValue('hscode.collapse')
                                currentTab == 1 ? getLangValueByKey('hscode.collapse') :
                                    getLangValueByKey('hscode.collapse',
                                        'en')
                            }}<i class="ri-arrow-up-s-line"></i></span>
                        <span class="cursor-pointer" v-else @click="group.expand = true"> {{
                            // getLangValue('hscode.expand')
                            currentTab == 1 ? getLangValueByKey('hscode.expand') : getLangValueByKey('hscode.expand',
                                'en')
                        }}<i class="ri-arrow-down-s-line"></i></span>
                    </div>
                </div>
                <div v-show="group.expand">
                    <!-- 指标 -->
                    <groupIndicatorListCom @showInfo="showInfo" v-model:indicatorList="group.indicatorList"
                        :isCheckForm="props.isCheckForm"
                        :index_standard_calculation_mode_list="index_standard_calculation_mode_list"
                        :category_name="group.category_name" :currentTab="currentTab" />
                    <!-- 分类组 -->
                    <div class=" my-2" v-for="(grop_son, grop_son_key) in group.children" :key="grop_son_key"
                        :id="`myGroup_${index}_${grop_son_key}`">
                        <div class="d-flex align-items-center justify-content-between py-2 ps-3 list-group-item"
                            style="border-bottom: 1px solid #E9EBEC;" draggable="true"
                            @dragstart="() => onDragStart(grop_son_key, 2)"
                            @dragover.prevent="onDragOver1(grop_son_key, index)" @drop="onDrop(2)">
                            <div style="min-width: 270px;">
                                <span class="me-2">{{
                                    // getLangValue('hscode.indicator_group')
                                    currentTab == 1 ? getLangValueByKey('hscode.indicator_group') :
                                        getLangValueByKey('hscode.indicator_group', 'en')
                                }}:</span>
                                <div style="font-size: 16px; width: 240px; display: inline-block;">
                                    <input @change="changeGroup(index, grop_son_key)"
                                        :disabled="!grop_son.add && !grop_son.canedit"
                                        style="width: 200px;display: inline-block;" v-model="grop_son.group_name"
                                        type="text" class="form-control " required :placeholder="
                                            // getLangValue('hscode.group_type_name')
                                            currentTab == 1 ? getLangValueByKey('hscode.group_type_name') : getLangValueByKey('hscode.group_type_name', 'en')
                                            " :class="[
                                                ((isCheckForm && grop_son.group_name === '')
                                                    || (repeatGroupList1[index] &&
                                                        repeatGroupList1[index].includes(grop_son.group_name))) && 'is-invalid',
                                            ]" v-show="currentTab == 1" />
                                    <input @change="changeGroup_en(index, grop_son_key)"
                                        :disabled="!grop_son.add && !grop_son.canedit"
                                        style="width: 200px;display: inline-block;" v-model="grop_son.group_name_en"
                                        type="text" class="form-control " required
                                        :placeholder="currentTab == 1 ? getLangValueByKey('hscode.group_type_name') : getLangValueByKey('hscode.group_type_name', 'en')"
                                        :class="[
                                            ((isCheckForm && grop_son.group_name_en === '')
                                                || (repeatGroupList1_en[index] &&
                                                    repeatGroupList1_en[index].includes(grop_son.group_name_en))) && 'is-invalid',
                                        ]" v-show="currentTab == 2" />
                                    <i class=" ri-delete-bin-fill mx-2 text-danger"
                                        @click="deleteGroupLevel2(index, grop_son_key)"
                                        v-if="grop_son.add || grop_son.canedit" />
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between">
                                <button type="button" class="btn btn-primary me-3 d-flex align-items-center"
                                    style="background-color: #0AB39C;border: unset;"
                                    @click="addGroupLevel3(index, grop_son_key)">
                                    <i class=" ri-add-fill me-2" />
                                    {{
                                        // getLangValue("hscode.add_group_son_type")
                                        currentTab == 1 ? getLangValueByKey('hscode.add_group_son_type') :
                                            getLangValueByKey('hscode.add_group_son_type', 'en')
                                    }}</button>
                                <span class="cursor-pointer"
                                    v-if="grop_son.expand || typeof grop_son.expand == 'undefined'"
                                    @click="grop_son.expand = false"> {{
                                        // getLangValue('hscode.collapse')
                                        currentTab == 1 ? getLangValueByKey('hscode.collapse') :
                                            getLangValueByKey('hscode.collapse',
                                                'en')
                                    }}<i class="ri-arrow-up-s-line"></i></span>
                                <span class="cursor-pointer" v-else @click="grop_son.expand = true"> {{
                                    // getLangValue('hscode.expand')
                                    currentTab == 1 ? getLangValueByKey('hscode.expand') :
                                        getLangValueByKey('hscode.expand',
                                            'en')
                                }}<i class="ri-arrow-down-s-line"></i></span>
                            </div>
                        </div>
                        <div v-show="grop_son.expand || typeof grop_son.expand == 'undefined'">
                            <!-- 指标 -->
                            <groupIndicatorListCom @showInfo="showInfo" v-model:indicatorList="grop_son.indicatorList"
                                :isCheckForm="props.isCheckForm"
                                :index_standard_calculation_mode_list="index_standard_calculation_mode_list"
                                :category_name="group.category_name" :currentTab="currentTab" />
                            <!-- 分类子组 -->
                            <div v-for="(grop_son_son, grop_son_son_key) in grop_son.children" :key="grop_son_son_key"
                                :id="`myGroup_${index}_${grop_son_key}_${grop_son_son_key}`">
                                <div class="d-flex align-items-center justify-content-start ps-5  py-2 list-group-item"
                                    style="border-bottom: 1px solid #E9EBEC;" draggable="true"
                                    @dragstart="() => onDragStart(grop_son_son_key, 3)"
                                    @dragover.prevent="onDragOver2(grop_son_son_key,index,grop_son_key )" @drop="onDrop(3)">
                                    <span class="me-2">{{
                                        // getLangValue('hscode.indicator_sub_group')
                                        currentTab == 1 ? getLangValueByKey('hscode.indicator_sub_group') :
                                            getLangValueByKey('hscode.indicator_sub_group', 'en')
                                    }}:</span>
                                    <div style="font-size: 16px; width: 240px; margin-right: auto;">
                                        <input @change="changeGroup1(index, grop_son_key)"
                                            :disabled="!grop_son_son.add && !grop_son_son.canedit"
                                            style="width: 200px;display: inline-block;"
                                            v-model="grop_son_son.group_name" type="text" class="form-control " required
                                            :placeholder="
                                                // getLangValue('hscode.group_son_type_name')
                                                currentTab == 1 ? getLangValueByKey('hscode.group_son_type_name') : getLangValueByKey('hscode.group_son_type_name', 'en')
                                                " :class="[
                                                    ((isCheckForm && !grop_son_son.group_name) || (repeatGroupList1[`${index}-${grop_son_key}_son`] && repeatGroupList1[`${index}-${grop_son_key}_son`].includes(grop_son_son.group_name) && (grop_son_son.add || grop_son_son.canedit))) && 'is-invalid',
                                                ]" v-show="currentTab == 1" />
                                        <input @change="changeGroup1_en(index, grop_son_key)"
                                            :disabled="!grop_son_son.add && !grop_son_son.canedit"
                                            style="width: 200px;display: inline-block;"
                                            v-model="grop_son_son.group_name_en" type="text" class="form-control "
                                            required :placeholder="
                                                // getLangValue('hscode.group_son_type_name')
                                                currentTab == 1 ? getLangValueByKey('hscode.group_son_type_name') : getLangValueByKey('hscode.group_son_type_name', 'en')
                                                " :class="[
                                                    ((isCheckForm && !grop_son_son.group_name_en) || (repeatGroupList1_en[`${index}-${grop_son_key}_son`] && repeatGroupList1_en[`${index}-${grop_son_key}_son`].includes(grop_son_son.group_name_en) && (grop_son_son.add || grop_son_son.canedit))) && 'is-invalid',
                                                ]" v-show="currentTab == 2" />
                                        <i class=" ri-delete-bin-fill mx-2 text-danger"
                                            @click="deleteGroupLevel3(index, grop_son_key, grop_son_son_key)"
                                            v-if="grop_son_son.add || grop_son_son.canedit" />
                                    </div>
                                    <span class="cursor-pointer"
                                        v-if="grop_son_son.expand || typeof grop_son_son.expand == 'undefined'"
                                        @click="grop_son_son.expand = false"> {{
                                            // getLangValue('hscode.collapse')
                                            currentTab == 1 ? getLangValueByKey('hscode.collapse') :
                                                getLangValueByKey('hscode.collapse',
                                                    'en')
                                        }}<i class="ri-arrow-up-s-line"></i></span>
                                    <span class="cursor-pointer" v-else @click="grop_son_son.expand = true"> {{
                                        // getLangValue('hscode.expand')
                                        currentTab == 1 ? getLangValueByKey('hscode.expand') :
                                            getLangValueByKey('hscode.expand',
                                                'en')
                                    }}<i class="ri-arrow-down-s-line"></i></span>
                                </div>
                                <div v-show="grop_son_son.expand || typeof grop_son_son.expand == 'undefined'">
                                    <groupIndicatorListCom @showInfo="showInfo"
                                        :index_standard_calculation_mode_list="index_standard_calculation_mode_list"
                                        v-model:indicatorList="grop_son_son.indicatorList"
                                        :isCheckForm="props.isCheckForm" :category_name="group.category_name"
                                        :currentTab="currentTab" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.group-content {
    .is-invalid {
        border: 1px solid #f06548;
        border-radius: 4px;
        padding-right: 0 !important;
    }



    .group {
        margin: 10px 0;

        .list-group-item {
            padding: 5px 2px;
            border-left: unset;
            border-right: unset;
            transition: transform 0.2s, background-color 0.2s;
            cursor: grab;
        }


        .list-group-item.dragging {
            opacity: 0.5;
            background-color: #d1e7ff;
            transform: scale(1.05);
        }

        .multiselect {
            margin: unset !important;
        }

        .group-index {

            .group-index-title,
            .group-index-input {
                display: flex;
                align-items: center;

                div {
                    flex: 1;
                    margin: 10px;
                }
            }
        }
    }

}
</style>